import React, { useState } from "react";
import {
  Typography,
  Box,
  Button,
} from "@mui/material";
import "./Aboutus.css";
import CallIcon from "@mui/icons-material/Call";
import useMediaQuery from "@mui/material/useMediaQuery";
import FormModal from "../pageComponents/FormModal";

const Custom = () => {
  const vMediaQuery = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
 
  const btnStyle = {
    color: "white",
    fontWeight: 600,
    borderRadius: "30px",
    padding: vMediaQuery ? "6px 14px" : "12px 16px",
    background: "linear-gradient(45deg, #42d1f5, #357ec7)",
    textTransform: "none",
    "&:hover": {
      background: "linear-gradient(45deg, #357ec7, #42d1f5)",
      color: "white",
      borderRadius: "30px",
      textDecoration: "underline",
    },
  };

  const handleOpen = () => {
    setOpen(true);

    setTimeout(() => {
      document.getElementById('from_firstname')?.focus();
    }, 400);
  };
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box
        sx={{
          flexGlow: 1,
          padding: vMediaQuery ? "40px 16px" : "60px 140px",
          textAlign: "center",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Typography
          variant="h4"
          color="#707070"
          sx={{ fontSize: vMediaQuery ? "22px" : "30px", padding: "16px 0px", fontFamily: "EB Garamond", }}
        >
          For any <strong style={{ color: "green" }}> GDR customization</strong>{" "}
          requirements, Schedule a Appointment!
        </Typography>

        <div className="CallBtn">
          <Button
            onClick={handleOpen}
            endIcon={
              <CallIcon
                sx={{
                  background: "white",
                  color: "#357ec7",
                  borderRadius: "50%",
                  padding: "6px",
                }}
              />
            }
            sx={btnStyle}
          >
            Schedule a Appointment Today!
          </Button>
        </div>
      </Box>
      <FormModal open={open} handleClose={handleClose}  />
    </>
  );
};

export default Custom;
